import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/admin/[id]/settings/page";

export const Route = createFileRoute("/admin/$id/settings")({
  component: Page,
});
